// frontend/src/utils/chartGroups.js
//
// The wire carries `category_label: null` for the group of items with no
// product category or no name.

/**
 * Give every group a name, replacing the wire's null with `fallbackName`.
 *
 * @param {Array<{category_label: ?string}>} groups  groups as served
 * @param {string} fallbackName  label or sentinel key for the unlabelled group
 * @returns {Array<{category_label: string}>} groups safe to key by name
 */
export function withGroupNames(groups, fallbackName) {
  if (!groups) return groups;
  return groups.map((g) => (
    g.category_label == null ? { ...g, category_label: fallbackName } : g
  ));
}
